import { render, staticRenderFns } from "./ItemExD.vue?vue&type=template&id=c11940d2"
import script from "./ItemExD.vue?vue&type=script&lang=js"
export * from "./ItemExD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports